<div class="form-horizontal">
  <div class="row align-items-center pb-2 d-flex justify-content-between">
    <div class="d-none d-sm-block col-sm-2">
      <small class="text-muted">{{'quantity' | translate | titlecase }}: {{model.envelopeAuthorizers?.length}}
      </small>
    </div>
    <div
      class="col-sm-10 d-flex flex-md-row-reverse align-items-center justify-content-end justify-content-md-start justify-content-sm-end toolbar">
      <div class="d-flex flex-md-row-reverse align-items-center">
        <cdx-toolbar-search (onTyping)="onSearch($event)" [value]="searchText"
          [placeholder]="'search' | translate | titlecase" [maxlength]="255" [debounceTime]="600">
        </cdx-toolbar-search>
        <div class="pl-1 d-flex ml-auto ml-md-0">
          <button class="cdx-button cdx-button--icon cdx-button--lg mr-1" [hidden]="!anyCheckedElement()"
            (click)="showConfirmationDelete(confirmDeleteModal)"
            ngbTooltip="{{'envelope.authorizer.tooltip.removeAuthorizer' | translate}}">
            <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','minus-circle']"></fa-icon>
          </button>
          <button class="cdx-button cdx-button--icon cdx-button--lg"
            (click)="showAddAuthorizerModal(modalAddAuthorizer)"
            ngbTooltip="{{'envelope.authorizer.tooltip.addAuthorizer' | translate}}">
            <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','plus-circle']"></fa-icon>
          </button>
        </div>
        <div class="d-none d-lg-block">
          <span class="d-flex ml-auto">
            <cdx-toggle-switch class="mr-1" [toggledOn]="model.authorizerAccessAuthentication"
              (toggle)="onToggleAccessAuthentication($event)">
            </cdx-toggle-switch>
            {{'envelope.authorizer.accessAuthentication' | translate}}
            <fa-icon ngbTooltip="{{'envelope.authorizer.tooltip.accessAuthentication' | translate}}" placement="left"
              class="ml-1 mr-1" size="sm" [icon]="['fas','question-circle']">
            </fa-icon>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="pl-2 pr-2">
  <ng-container *ngIf="model.envelopeAuthorizers.length > 0; else blankSlateTable">
    <cdx-data-table [options]="dataTableOptions" (onDataTableChange)="onDataTableChange($event)"></cdx-data-table>
  </ng-container>
</div>

<div class="row d-lg-none mt-1">
  <div class="col-12">
    <span class="d-flex ml-auto">
      <cdx-toggle-switch class="mr-2" [toggledOn]="model.authorizerAccessAuthentication"
        (toggle)="onToggleAccessAuthentication($event)">
      </cdx-toggle-switch>
      {{'envelope.authorizer.accessAuthentication' | translate}}
      <fa-icon ngbTooltip="{{'envelope.authorizer.tooltip.accessAuthentication' | translate}}" placement="left"
        class="ml-1 fa-gray" size="sm" [icon]="['fas','question-circle']">
      </fa-icon>
    </span>
  </div>
</div>
<ng-template #blankSlateSearchTemplate>
  <ng-container>
    <cdx-blankslate [options]="blankSlateSearch" (buttonClick)="onBlankSlateSearchClick($event)">
      {{'envelope.authorizer.blankSlateSearchText' | translate}}</cdx-blankslate>
  </ng-container>
</ng-template>
<ng-template #blankSlateTable>
  <div class="p-2 table__container">
    <ng-container *ngIf="(searchText === ''); else blankSlateSearchTemplate">
      <cdx-blankslate [options]="blankSlate" (buttonClick)="showAddAuthorizerModal(modalAddAuthorizer)">
        <span [innerHTML]="'envelope.authorizer.blankSlateText' | translate"></span>
      </cdx-blankslate>
    </ng-container>
  </div>
</ng-template>

<ng-template #modalAddAuthorizer>
  <app-participant-modal
    (closeModalClick)="closeModalClick()"
    (submitModalClick)="submitAddModalClick($event)"
    [participantTypeInput]="participantType.Authorizer"
    [enableEditContact]="true">
  </app-participant-modal>
</ng-template>

<ng-template #confirmDeleteModal>
  <app-confirm-modal
    [HeaderText]="'envelope.authorizer.confirm-disassociate-delete-modal.headerText'"
    [MessageText]="'envelope.authorizer.confirm-disassociate-delete-modal.messageText'"
    (closeModalClick)="confirmModalClose()"
    (confirmModalClick)="confirmModalYesClick()"
    [ButtonConfirmText]="'disassociateModalActions.remove'"
    [ButtonCancelText]="'disassociateModalActions.cancel'"
    [IsApprovalConfirm]="false"
    [modalIntentType]="modalIntentType.DANGER"
  >
  </app-confirm-modal>
</ng-template>